import { createContext, useContext, Dispatch } from "react";
import { State, Action } from "./definitions";
import { Actions } from "./actions";

interface ContextInterface {
  state: State;
  dispatch: Dispatch<Action>;
  Actions: typeof Actions;
}

export const BookTelephoneBoxContext = createContext({} as ContextInterface);

export function useBookTelBox(): ContextInterface {
  return useContext(BookTelephoneBoxContext);
}

export { initialState } from "./definitions";
export { reducer } from "./reducer";
export { Actions } from "./actions";
